// Misc
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'

// Atoms
import Link from './Link'

// Styles
const styles = {
  root: {
    outline: 0,
  }
}

const LinkMenuItem = ({ classes, className, ...rest }) => (
  <MenuItem
    {...rest}
    component={Link}
    className={classNames(classes.root, className)}
  />
)

LinkMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
}

export default withStyles(styles)(LinkMenuItem)
